import type { ReactNode } from "react";
import { MantineProvider } from "@mantine/core";

import { mantineTheme } from "./mantine-theme";

/**
 * Wraps the SPA (and the test harness) in Mantine's theme.
 *
 * Forced light for now: the product is an operator console watched in shops
 * and warehouses, and a dark default would fight the printed documents
 * (temperature record, loan agreement) that share the same tokens.
 */
export function AppThemeProvider({ children }: { children: ReactNode }) {
  return (
    <MantineProvider theme={mantineTheme} defaultColorScheme="light" forceColorScheme="light">
      {children}
    </MantineProvider>
  );
}
